import type { StudentSidebarConversationRowResource } from "api/generated";
import type { StudentSidebarConversationRow } from "conversations/types";
import { parseSchoolDateTime } from "shared/utils";

/**
 * Maps one row of the Gesprekken tab in the leerling-sidebar.
 *
 * `date` carries a Dutch wall-clock moment, so it is read through the school clock rather
 * than the browser's timezone — same as `studentConversationRowFromDto`, which maps the
 * same gesprek for the leerling.
 */
export const studentSidebarConversationRowFromDto = (
  dto: StudentSidebarConversationRowResource,
): StudentSidebarConversationRow => ({
  id: dto.id,
  name: dto.name,
  date: parseSchoolDateTime(dto.date),
  endDate: parseSchoolDateTime(dto.end_date),
  conversationType: {
    id: dto.conversation_type.id,
    name: dto.conversation_type.name,
  },
  partner:
    dto.partner === null
      ? null
      : {
          name: dto.partner.name,
          avatar: dto.partner.avatar,
        },
  teacherShortage: dto.teacher_shortage ?? null,
  isNote: dto.is_note,
  isPrepared: dto.is_prepared,
  status: dto.status,
  canView: dto.can_view,
});
